import i18n from "i18next";
import { initReactI18next } from "react-i18next";
///import ChainedBackend from "i18next-chained-backend";
import HttpBackend from "i18next-http-backend";
// import AsyncStorageBackend from "i18next-async-storage-backend";

// the translations
// (tip move them in a JSON file and import them,
// or even better, manage them separated from your code: https://react.i18next.com/guides/multiple-translation-files)
const resources = {
  en: {
    translation: {
      title: "Installation of mobile device certificates",
      form: {
        instructions: "Enter the codes you received via email and SMS, as well as your username and password",
        qrCodeLabel: "Enter QR code",
        smsCodeLabel: "Enter SMS code",
        usernameLabel: "Enter username",
        adPasswordLabel: "Enter password",
        issueButton: "Issue button",
        certPassword: "Your certificate password",
        certPasswordClibpoard: "Certificate password copied to clipboard",
        clipboardError: "Error copying to clipboard",
        issuing: "Issuing certificate. Please wait.",
      },
      error: {
        title: "Error",
        wrongOsOrBrowser: "To receive the certificate, you must open the page on an Android device in the Chrome browser or on an iOS device in the Safari browser",
      },
    },
  },
  si: {
    translation: {
      title: "Prevzem potrdil za mobilne naprave",
      form: {
        instructions: "Vpišite kodi, ki ste ju prejeli na elektronski naslov in SMS ter vaše uporabniško ime in geslo",
        qrCodeLabel: "Vpišite QR kodo",
        smsCodeLabel: "Vpišite SMS kodo",
        usernameLabel: "Vpišite uporabniško ime",
        adPasswordLabel: "Vpišite geslo",
        issueButton: "Prevzemi potrdilo",
        certPassword: "Geslo za potrdilo je",
        certPasswordClibpoard: "Geslo uspešno kopirano na odložišče",
        clipboardError: "Napaka pri kopiranju na odložišče",
        issuing: "Poteka izdajanje potrdila, prosimo počakajte...",
      },
      error: {
        title: "Napaka",
        certError: "Napaka pri prevzemu potrdila. Ste vpisali pravilne podatke?",
        wrongOsOrBrowser: "Za prevzem potrdila morate stran odpreti na napravi Android v brskalniku Chrome ali na napravi iOS v brskalniku Safari",
      },
    },
  },
};

// console.log(JSON.stringify(resources.si));
// console.log(window.navigator.language);
i18n
  .use(HttpBackend)
  .use(initReactI18next) // passes i18n down to react-i18next
  .init({
    load: 'languageOnly',
    initImmediate: false,
    fallbackLng: "en",
    compatibilityJSON: 'v1',
    // resources,
    lng: window.navigator.language == "sl-SI" ? "si" : "en",
    //lng: "si", // language to use, more information here: https://www.i18next.com/overview/configuration-options#languages-namespaces-resources
    // you can use the i18n.changeLanguage function to change the language manually: https://www.i18next.com/overview/api#changelanguage
    // if you're using a language detector, do not define the lng option
    backend: {
      loadPath: '/locales/{{lng}}.json',
      // parse: function(data:any) {
      //   // console.log("parse: " + data, 'data parse');
      //   return data;
      // },
    },
  }, (()=>{
    // console.log(i18n.t("title"));
    // console.log(i18n.t("translation.title"));
    // console.log(JSON.stringify(i18n))
  }));

export default i18n;
